import React, { useEffect, Fragment, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import {
  GetConsultantSpecializationById,
  UpdateConsultantSpecialization
} from "../../../api/masters/consultantSpecializationAPI";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  nature: yup.string().required("Nature is required")
});

const EditDepartment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchData = async () => {
    try {
      const response = await GetConsultantSpecializationById(id); // Make sure login function returns token

      if (response.success) {
        setValue("name", response.data.name);
        setValue("nature", response.data.nature);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(
    () => {
      const loadData = async () => {
        try {
          dispatch({ type: "LOADER_START" });

          await fetchData();
        } catch (error) {
          showToast("error", error);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      };

      loadData();
    },
    [id]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateConsultantSpecialization(id, data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb
        parent="Consultant Specialization"
        title="Edit Consultant Specialization"
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Edit Consultant Specialization</h5>
                  <Link to={`/masters/consultant-specialization/list`}>
                    <button className="btn btn-primary" id="list">
                      List Consultant Specialization
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Consultant Specialization
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Name*</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="nature">Nature*</label>
                        <select
                          className="form-select"
                          id="nature"
                          type="text"
                          placeholder="Nature"
                          {...register("nature")}
                        >
                          <option value="">Please select</option>
                          <option value="Surgeon">Surgeon</option>
                          <option value="Anesthesia">Anesthesia</option>
                          <option value="Physician">Physician</option>
                          <option value="Radiologist">Radiologist</option>
                          <option value="Phathologist">Phathologist</option>
                          <option value="Others">Others</option>
                        </select>
                        {errors.nature &&
                          <p className="text-danger">
                            {errors.nature.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditDepartment;
